import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { AppRootState, rootPersistConfig, rootReducer } from './rootReducer';
import storage from 'redux-persist/lib/storage';

//remove unused, prevously created persisted stores
storage.removeItem('redux-organization');
storage.removeItem('redux-infoMessages');

// ----------------------------------------------------------------------

const store = configureStore({
  reducer: persistReducer<AppRootState>(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    })
});

const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

const useSelector = useReduxSelector;
const useDispatch = () => useReduxDispatch<AppDispatch>();

export { store, persistor, dispatch, useSelector, useDispatch };
